export default {
	type: 'panel',
	name: 'help',
	blocks: [
		{
			name: 'parent', // slug of the parent help panel (same language); empty means root
			label: 'Parent',
			type: 'panel',
			max: 1,
		},
		{
			name: 'content',
			type: 'mixed',
			blocks: [
				{
					name: 'anchor',
					type: 'text',
					max: 1,
				},
				{
					name: 'title',
					type: 'text',
					max: 1,
				},
				{
					name: 'text', // name or id; MUST be unique
					type: 'html', // || text || link || image || mixed (with children)
					max: 1, // max same items allowed
				},
				{
					name: 'image',
					type: 'image',
					max: 1,
				},
			],
		},
	],
};
